<template>
    <div>
        <portlet
                :icon="'fi flaticon-star'"
                :title="'Producten'"
                :actionBlock="true"
                :actions="[{name:'Product toevoegen',url:'/create'} ]"
        >
            <div slot="actionsBlock">
                <router-link tag="button" :to="{name:'product-create'}" class="btn btn-primary">Product toevoegen</router-link>
            </div>

            <div slot="portletBody">

                <input type="text" class="form-control mb-4" v-model="search" placeholder="Product zoeken...">
                <div v-model="getProductList">
                    <div v-for="(product, index) in filteredProductsList" :key="index" class="item-row">
                        <span class="product-norm">{{product.norm}} %</span>
                        <span class="product-name">| {{product.name}}</span>
                        <span class="item-actions">
                            <router-link :to="'/products/'+ product.id">
                                <i class="fas fa-pencil product-edit"></i>
                            </router-link>
                            <a href="javascript:;" @click="deleteProduct(product.id)" class="product-icon"><i class="fas fa-trash product-remove"></i></a>
                        </span>
                    </div>
                </div>
                <div class="item-row" v-if="filteredProductsList.length < 1">
                    <span v-show="search">
                        Er zijn geen zoekresultaten met: {{search}}
                    </span>
                </div>

            </div>
        </portlet>
    </div>
</template>

<style lang="scss">
    .m-portlet .m-portlet__head .m-portlet__head-tools {
        flex-direction: row-reverse;
    }
</style>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {

        data() {
            return {
                search: '',
            }
        },
        computed: {
            ...mapGetters('products', [
                'getProducts'
            ]),
            getProductList: {
                get() {
                    return this.$store.state.products;
                },
                set(value) {
                    this.$store.commit('products/', value)
                }
            },
            filteredProductsList() {
                var self = this

                return this.getProducts.filter(function (product) {
                    return product.name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                });
            }
        },
        methods: {
            ...mapActions('products', [
                'getProductsFromApi',
                'deleteProduct'
            ]),
        },
        updated(){
            $('[data-toggle="tooltip"]').tooltip()
        },
        created() {

            this.getProductsFromApi()
        }
    }
</script>


